import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs, orderBy, query, deleteDoc, doc } from 'firebase/firestore';

const AdminPortal = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loginData, setLoginData] = useState({ user: '', pass: '' });
    const [inquiries, setInquiries] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const users = [
    { username: "omesh", password: "omesh123" },
    { username: "admin", password: "admin123" },
    { username: "arush", password: "AMEO@1320" }
];

const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to permanently delete this inquiry?");
    if (!confirmDelete) return;

    try {
        await deleteDoc(doc(db, "all_inquiries", id));
        setInquiries(prev => prev.filter(item => item.id !== id));
        setSelectedItem(null);
    } catch (error) {
        console.error("Error deleting document:", error);
        alert("Failed to delete inquiry.");
    }
};

const handleLogin = (e) => {
    e.preventDefault();

    const isValidUser = users.some(
        (user) =>
            user.username === loginData.user &&
            user.password === loginData.pass
    );

    if (isValidUser) {
        setIsAuthenticated(true);
        fetchData();
    } else {
        alert("Unauthorized access denied.");
    }
};

    const fetchData = async () => {
        setLoading(true);
        try {
            const q = query(collection(db, 'all_inquiries'), orderBy('timestamp', 'desc'));
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setInquiries(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            setInquiries([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated) fetchData();
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return (
            <div style={styles.loginContainer}>
                <div style={{ ...styles.loginCard, width: isMobile ? '85%' : '380px' }}>
                    <h2 style={styles.loginTitle}>Admin Authentication</h2>
                    <form onSubmit={handleLogin}>
                        <input
                            style={styles.richInput}
                            placeholder="Username"
                            onChange={(e) => setLoginData({ ...loginData, user: e.target.value })}
                        />
                        <input
                            style={styles.richInput}
                            type="password"
                            placeholder="Password"
                            onChange={(e) => setLoginData({ ...loginData, pass: e.target.value })}
                        />
                        <button type="submit" style={styles.loginBtn}>Verify Identity</button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.adminWrapper}>
            <nav style={styles.navBar}>
                <div style={styles.adminLogo}>OMESH CONSOLE</div>
                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                    <p style={styles.logoutLink} onClick={() => setIsAuthenticated(false)}>Logout</p>
                </div>
            </nav>

            <div style={{ ...styles.mainContent, marginTop: '70px', padding: isMobile ? '20px' : '40px 60px' }}>
                <div style={styles.header}>
                    <div>
                        <h1 style={{...styles.title, fontSize: isMobile ? '24px' : '32px'}}>Brand Inquiries</h1>
                        <p style={styles.subtitle}>Consolidated Master List</p>
                    </div>
                    <button
                        onClick={fetchData}
                        style={loading ? styles.refreshBtnLoading : styles.refreshBtn}
                        disabled={loading}
                    >
                        {loading ? '...' : '↻ Refresh'}
                    </button>
                </div>

                <div style={{ ...styles.tableCard, overflowX: 'auto' }}>
                    <table style={{ ...styles.table, minWidth: isMobile ? '800px' : '100%' }}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Brand / Type</th>
                                <th style={styles.th}>Founder</th>
                                <th style={styles.th}>Contact</th>
                                <th style={styles.th}>Infrastructure</th>
                                <th style={styles.th}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inquiries.length > 0 ? inquiries.map((item) => (
                                <tr key={item.id} style={styles.tr}>
                                    <td style={styles.td}>
                                        <strong>{item.brandName || 'Unnamed'}</strong><br />
                                        <span style={styles.categoryBadge}>{item.category || 'general'}</span>
                                    </td>
                                    <td style={styles.td}>{item.ownerName}</td>
                                    <td style={styles.td}>
                                        {item.whatsapp}<br />
                                        <span style={{ fontSize: 12, color: '#888' }}>{item.email}</span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{ color: item.customDomain ? '#00c853' : '#ff3d00' }}>
                                            {item.customDomain ? '✓ Domain' : '✗ Domain'}
                                        </span><br />
                                        <span style={{ color: item.mailIntegration ? '#00c853' : '#ff3d00' }}>
                                            {item.mailIntegration ? '✓ Mail' : '✗ Mail'}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <button style={styles.openBtn} onClick={() => setSelectedItem(item)}>Review</button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>No leads found in all_inquiries.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Side Detail Panel */}
            {selectedItem && (
                <div style={styles.overlay} onClick={() => setSelectedItem(null)}>
                    <div 
                        style={{ 
                            ...styles.sidePanel, 
                            width: isMobile ? '100%' : '550px',
                            padding: isMobile ? '40px 20px' : '60px 40px'
                        }} 
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button style={styles.closeBtn} onClick={() => setSelectedItem(null)}>✕</button>

                        <h2 style={{...styles.panelTitle, fontSize: isMobile ? '22px' : '28px'}}>{selectedItem.brandName || 'Inquiry Details'}</h2>
                        <span style={styles.categoryBadge}>{selectedItem.category}</span>

                        <div style={styles.panelDivider} />

                        <div style={styles.detailList}>
                            {/* SECTION 01: IDENTITY */}
                            <h3 style={styles.sectionLabel}>01. Identity & Contact</h3>
                            <div style={{...styles.grid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'}}>
                                <Field label="FOUNDER / DIRECTOR" value={selectedItem.ownerName} />
                                <Field label="BUSINESS EMAIL" value={selectedItem.email} />
                                <Field label="WHATSAPP" value={selectedItem.whatsapp} />
                                <Field label="INSTAGRAM" value={selectedItem.instagram} />
                            </div>

                            {/* SECTION 02: BUSINESS METRICS */}
                            <h3 style={styles.sectionLabel}>02. Business Metrics</h3>
                            <Field label="HEADQUARTERS" value={selectedItem.address} />
                            <div style={{...styles.grid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'}}>
                                <Field label="PROJECT BUDGET" value={selectedItem.budget} />
                                <Field label="VOLUME/METRIC" value={selectedItem.orderVolume} />
                            </div>

                            {/* SECTION 03: BRAND SCOPE */}
                            <h3 style={styles.sectionLabel}>03. Brand Scope</h3>
                            <div style={{...styles.grid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'}}>
                                <Field label="EST. STOCK COUNT" value={selectedItem.productCount} />
                                <Field label="UI PREFERENCE" value={selectedItem.colorScheme} />
                            </div>
                            <Field label="SPECIFIC OFFERINGS / PHILOSOPHY" value={selectedItem.productType} />

                            {/* SECTION 04: INFRASTRUCTURE */}
                            <h3 style={styles.sectionLabel}>04. Digital Infrastructure</h3>
                            <div style={{...styles.grid, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'}}>
                                <Field label="CUSTOM DOMAIN" value={selectedItem.customDomain ? 'REQUIRED' : 'NOT REQ'} />
                                <Field label="MAIL INTEGRATION" value={selectedItem.mailIntegration ? 'REQUIRED' : 'NOT REQ'} />
                                <Field label="SEO STRATEGY" value={selectedItem.seoType?.toUpperCase()} />
                            </div>

                            {/* SECTION 05: SYSTEM DATA */}
                            <h3 style={styles.sectionLabel}>System Metadata</h3>
                            <Field label="SUBMISSION DATE" value={selectedItem.timestamp?.toDate().toLocaleString()} />
                            <Field label="FIREBASE ID" value={selectedItem.id} />
                        </div>
                        <button
    style={styles.deleteModalBtn}
    onClick={() => handleDelete(selectedItem.id)}
>
    Delete Inquiry
</button>
                    </div>
                </div>
            )}
        </div>
    );
};

const Field = ({ label, value }) => (
    <div style={styles.fieldItem}>
        <div style={styles.fieldLabel}>{label}</div>
        <div style={styles.fieldValue}>{value || 'N/A'}</div>
    </div>
);

const styles = {
    loginContainer: { height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9f9f9' },
    loginCard: { padding: '50px', backgroundColor: '#fff', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.05)', textAlign: 'center' },
    loginTitle: { fontSize: '20px', fontWeight: '800', marginBottom: '30px', letterSpacing: '1px' },
    loginBtn: { width: '100%', padding: '16px', backgroundColor: '#000', color: '#fff', border: 'none', borderRadius: '12px', fontWeight: '700', cursor: 'pointer' },
    adminWrapper: { display: 'flex', minHeight: '100vh', backgroundColor: '#fff', flexDirection: 'column', fontFamily: '"Inter", sans-serif' },
    navBar: { height: '70px', width: '100%', backgroundColor: '#000', color: '#fff', position: 'fixed', top: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', zIndex: 100 },
    adminLogo: { fontSize: '14px', fontWeight: '900', letterSpacing: '3px' },
    logoutLink: { fontSize: '12px', cursor: 'pointer', color: '#ff4444',marginRight:50 },
    mainContent: { flex: 1 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' },
    title: { fontWeight: '900', margin: 0, letterSpacing: '-1px' },
    subtitle: { color: '#aaa', fontSize: '14px' },
    refreshBtn: { padding: '12px 24px', backgroundColor: '#000', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '600', cursor: 'pointer' },
    refreshBtnLoading: { padding: '12px 24px', backgroundColor: '#eee', color: '#999', border: 'none', borderRadius: '10px' },
    tableCard: { border: '1px solid #f0f0f0', borderRadius: '20px', backgroundColor: '#fff' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: '20px', textAlign: 'left', color: '#bbb', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', borderBottom: '1px solid #f5f5f5' },
    tr: { borderBottom: '1px solid #f9f9f9' },
    td: { padding: '20px', fontSize: '14px', verticalAlign: 'top' },
    categoryBadge: { fontSize: '10px', padding: '2px 8px', backgroundColor: '#f0f0f0', borderRadius: '4px', textTransform: 'uppercase', fontWeight: '700', color: '#666', marginTop: '4px', display: 'inline-block' },
    openBtn: { padding: '8px 16px', backgroundColor: '#f5f5f5', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '700', fontSize: '12px' },
    overlay: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1000 },
    sidePanel: { backgroundColor: '#fff', height: '100vh', position: 'absolute', right: 0, overflowY: 'auto', boxShadow: '-10px 0 30px rgba(0,0,0,0.05)', boxSizing: 'border-box' },
    closeBtn: { float: 'right', border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer' },
    panelTitle: { fontWeight: '900' },
    panelDivider: { height: '1px', backgroundColor: '#eee', margin: '30px 0' },
    sectionLabel: { fontSize: '11px', color: '#000', fontWeight: '900', textTransform: 'uppercase', marginTop: '30px', marginBottom: '15px' },
    fieldItem: { marginBottom: '15px' },
    fieldLabel: { fontSize: '9px', color: '#aaa', fontWeight: '800' },
    fieldValue: { fontSize: '15px', color: '#111', marginTop: '2px' },
    richInput: { width: '100%', padding: '15px', border: '1px solid #eee', borderRadius: '10px', marginBottom: '15px' },
    grid: { display: 'grid', gap: '15px', marginBottom: '10px' },
    detailList: { paddingBottom: '40px' }
};

export default AdminPortal;